import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/collapsible-card/collapsible-card.module.css
var css_248z = ".collapsible-card-module_collapse__1y-zj {\n    div:has(> &[data-state]) {\n        transition: margin-top 200ms ease;\n    }\n\n    div:has(> &[data-state='closed']) {\n        margin-top: calc(var(--mantine-spacing-sm) * -1);\n    }\n}\n";
var collapsible_card_module_default = { "collapse": "collapsible-card-module_collapse__1y-zj" };
style_inject_es_default(css_248z);

//#endregion
export { collapsible_card_module_default as default };